import Axios from 'axios';
import { API_HOST, axiosInstance, axiosRequestWithAuth, UI_DOMAIN } from '../constants/server.constant';
import SessionService from './session.service';
import { userService } from './user.service';

async function validateIsHuman(token) {
    return await Axios.post("https://www.google.com/recaptcha/api/siteverify?secret=6Lf4e_QZAAAAAA7CznFl6j61vCx1blDE3QARBiMQ&response=" + token)
        .then((data) => {
            return data.success;
        }).catch((err) => {
            return false;
        });
}

const authenticate = async (captcha, payload) => {
    return await Axios.post(API_HOST + "/login/authenticate?captcha=" + captcha, payload, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(err => {
        throw err;
    });
};

const thirdPartyAuthenticate = async (payload) => {
    return await Axios.post(API_HOST + "/login/thirdPartyAuthenticate", payload, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(err => {
        throw err;
    });
};

const autoAuthenticate = async (payload) => {
    return await Axios.post(API_HOST + "/login/authenticate", payload, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(err => {
        throw err;
    });
};

const authenticateSupport = async (payload) => {
    return await Axios.post(API_HOST + "/login/authenticate/support", payload, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(err => {
        throw err;
    });
};

const tryRefresh = async () => {
    return await Axios.get(API_HOST + "/login/authenticate/refresh", axiosRequestWithAuth).then(resp => {
        if(resp?.data?.redirect) {
            if(String(resp.data.redirect).startsWith("/2fa")) {
                // take substring to account for base path `/app`
                SessionService.setCookie("_redirect_url", window.location.pathname.substring(4));
            }
            this.props.history.push(resp.data.redirect);
        }
        userService.getUserData().then(resp => {
            loginService.setUserLocal(resp);
        }).catch(error => {
            if(error?.response) {
                loginService.redirectToLogin();
            } else {
                return;
            }
        });
    }).catch(error => {
        throw error;
    });
};

const setUserLocal = (response, inSession) => {
    let user;
    if(response?.data?.body) {
        user = response.data.body;
    } else {
        user = response.data;
    }
    localStorage.setItem("roleId", user.role.id);
    localStorage.setItem("userId", user.id);
    localStorage.setItem("firstName", user.firstName);
    localStorage.setItem("email", user.email);
    localStorage.setItem("lastName", user.lastName);
    localStorage.setItem("countryCode", user.countryCode);
    localStorage.setItem("phone", user.phone);
    localStorage.setItem("status", user.status);

    if(!inSession) {
        localStorage.setItem("notifyCount", "show");
        localStorage.setItem("clusterMessage", "show");
        SessionService.setCookie("_bm_count", "show");
        SessionService.setCookie("_banner_show", "show");
    }

    window.dispatchEvent(new Event("storage"));
};

const redirectToLogin = (userId, removeRedirect) => {
    const id = typeof userId !== 'undefined' ? userId : localStorage.getItem("userId");

    localStorage.clear();
    sessionStorage.clear();
    if(removeRedirect) loginService.deleteCookie("_redirect_url", "/app");
    window.location.href = API_HOST + "/login/logout?userId=" + id;
    return null;
};

const clearLocalSession = (userId) => {
    SessionService.removeCookie("isLoggedIn", { path: "/", domain: UI_DOMAIN });
    localStorage.clear();
    sessionStorage.clear();
    return null;
};

const logoutUser = async (userId) => {
    await axiosInstance.get(API_HOST + "/login/logout?userId=" + userId + "&shouldRedirect=false", axiosRequestWithAuth).then(response => {
        return response;
    }).catch(error => {
        return Promise.reject(error);
    });
};

const deleteCookie = (name, path) => {
    document.cookie = name + "=; path=`" + (typeof path === 'undefined' ? "/" : path) + "`; domain=" + UI_DOMAIN + "; expires=Thu, 01 Jan 1970 00:00:01 GMT";
};

const executeGoogleScript = () => {
    window['google_conversion_id'] = 1060449053;
    window['google_conversion_language'] = 'en';
    window['google_conversion_format'] = "3";
    window['google_conversion_color'] = "ffffff";
    window['google_conversion_label'] = "zi5qCM6e5mQQndbU-QM";
    window['google_remarketing_only'] = false;
    const script = document.createElement('script');

    script.src = "//www.googleadservices.com/pagead/conversion.js";
    script.type = "text/javascript";
    document.body.append(script);
};

const isInternalUser = () => {
    let email = localStorage.getItem('email');
    if(!email) return false;
    return email.endsWith('@idrive.com') || email.endsWith('@zipdrive.com') || email.endsWith('@idriveinc.com') || email.endsWith("@vitech.dev");
};

export const loginService = {
    validateIsHuman,
    authenticate,
    thirdPartyAuthenticate,
    autoAuthenticate,
    authenticateSupport,
    tryRefresh,
    setUserLocal,
    redirectToLogin,
    clearLocalSession,
    logoutUser,
    deleteCookie,
    executeGoogleScript,
    isInternalUser
};
